export default {
    _graystrokeregular: 'graystrokeregular',
    _retrigaregular: 'retrigaregular',
}